// src/components/layouts/PanelLayout.jsx

import React from "react";
import { useLocation } from "react-router-dom";
import NavigationPortal from "./navPortal";
import HeaderEmpleado from "../components/pages/gestionEmpleados/HeaderEmpleado";

function PanelLayout({ children }) {
  const location = useLocation();

  // 🔹 Detectar si estamos en rutas de empleado
  const path = location.pathname.toLowerCase();

  const esRutaEmpleado =
    path.includes("dashboardempleados") ||
    path.includes("misrecibos") ||
    path.includes("perfilEmpleado");

  return (
    <div>
      {/* Mostrar menú según ruta */}
      {esRutaEmpleado ? <HeaderEmpleado /> : <NavigationPortal />}

      <div className="flex-grow-1 bg-body p-4">
        {children}
      </div>
    </div>
  );
}

export default PanelLayout;
